<template>
  <div class="jumbotron d-flex flex-column justify-content-center align-items-center w-100 h-100 bg-white mx-auto">
    <Logo />
    <svg id="scrollicon" width="40px" height="100%" viewBox="0 0 247 390" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:1.5;">
      <path id="wheel" d="M123.359,79.775l0,72.843" style="fill:none;stroke:#000;stroke-width:10px;"/>
      <path id="mouse" d="M236.717,123.359c0,-62.565 -50.794,-113.359 -113.358,-113.359c-62.565,0 -113.359,50.794 -113.359,113.359l0,143.237c0,62.565 50.794,113.359 113.359,113.359c62.564,0 113.358,-50.794 113.358,-113.359l0,-143.237Z" style="fill:none;stroke:#000;stroke-width:10px;"/>
    </svg>
  </div>
</template>

<script>
  import Logo from './Logo.vue'

  export default {
    name: 'HelloWorld',
    props: {
      msg: String
    },
    components: {
      Logo
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .h-100 {
    height: 100vh!important;
  }

  .w-100 {
    width: 100vw!important;
  }

  @keyframes scroll {
    0% {
      transform: translateY(0);
    }
    30% {
      transform: translateY(60px);
    }
  }

  #scrollicon {
    position: absolute;
    top: 38vh;
  }

  svg #wheel {
    animation: scroll ease 2s infinite;
  }
</style>
